module.exports = __webpack_public_path__ + "img/ledger.4b29aff1.png";